/**
 * 通用模块配置
 */

export * from '@/pages/common/app-mixin'
import router from '@/pages/common/router'
import store from '@/pages/common/store'

export const mapCommonRouter = router
export const mapCommonStore = store
